import AllhomesLogo from './allhomes-logo';
export default AllhomesLogo;